const GAP_SUPABASE_URL = "https://kpfmkkztgqjqokvfayca.supabase.co";
const GAP_SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwZm1ra3p0Z3FqcW9rdmZheWNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2MTU1MzYsImV4cCI6MjA4NjE5MTUzNn0.3SALiL1O_m5kJEuYC6PDUhT4-0oBI5s4mTU8LWWzRV8";

export async function getGAPBlogPosts(clientId) {
  try {
    const res = await fetch(
      `${GAP_SUPABASE_URL}/rest/v1/content_projects?client_id=eq.${clientId}&blog_title=not.is.null&blog_content=not.is.null&order=created_at.desc&limit=50`,
      {
        headers: {
          apikey: GAP_SUPABASE_ANON_KEY,
          Authorization: `Bearer ${GAP_SUPABASE_ANON_KEY}`,
        },
      }
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data.filter((post) => post.blog_title && post.blog_content);
  } catch {
    return [];
  }
}

export function slugify(title) {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function estimateReadTime(content) {
  const words = content.replace(/<[^>]*>/g, "").split(/\s+/).length;
  return `${Math.max(1, Math.round(words / 200))} min read`;
}

export function extractExcerpt(html, maxLength = 200) {
  const text = html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).replace(/\s\S*$/, "") + "...";
}
